import { render, staticRenderFns } from "./MailTemplatesTable.vue?vue&type=template&id=101ff241&"
import script from "./MailTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./MailTemplatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports